var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("multi-input", {
    attrs: {
      readonly: "",
      value: _vm.value,
      prop: _vm.prop,
      label: _vm.label,
      count: _vm.count,
      rules: _vm.rules
    },
    on: { input: _vm.input }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }